import { module as BaseModule } from "modujs";

const ACTIVE_CLASS = "is-current-day";

export default class FreeEstimateHours extends BaseModule {
  init() {
    this.markCurrentDay();
  }

  markCurrentDay() {
    const currentDayName = this.getCurrentDayName();
    if (!currentDayName) {
      return;
    }

    this.el.querySelectorAll("[data-day]").forEach((item) => {
      const label = item.getAttribute("data-day")?.trim().toLowerCase();
      if (label === currentDayName) {
        item.classList.add(ACTIVE_CLASS);
      }
    });
  }

  getCurrentDayName() {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const today = new Date().getDay();

    return days[today];
  }
}
